// @flow
import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import * as typography from '@components/shared/typography'
import { config } from 'react-awesome-styled-grid'
import { FadeInImage } from '@components/shared/FadeInImage'

type PropsType = { title: string, subtitle: string, imageUrl: string}

export function CelebrityBanner (props: PropsType): React.Node {
  return (
    <FeaturedContainer>
      <FeaturedImage><FadeInImage src={props.imageUrl} width={200} height={200}/></FeaturedImage>
      <FeaturedTextContainer>
        <FeaturedTitle>{props.title}</FeaturedTitle>
        <FeaturedSubtitle>{props.subtitle}</FeaturedSubtitle>
      </FeaturedTextContainer>

    </FeaturedContainer>
  )
}

const FeaturedContainer = styled.div`
    border: 1px solid ${colors.white};
    width: 100%;
    padding: 8px;
    border-radius: 8px;
    display: flex;
    ${(props: any): string => config(props).media.md`
      padding: 16px;
      max-width: 450px;
    `}
`
const FeaturedImage = styled.div`
    margin-right: 8px;
    height: 80px;
    width: 80px;
    img {
        border-radius: 16px;    
    }
    ${(props: any): string => config(props).media.md`
      img {
          height: 100px;
          width: 100px;
          border-radius: 16px;
      }
    `}

`
const FeaturedTitle = styled.div`
    ${typography.GoodSansH2};
    color: ${colors.white};
    margin-bottom: 6px;
    ${(props: any): string => config(props).media.md`
      margin-bottom: 8px;
    `}
`
const FeaturedSubtitle = styled.div`
    ${typography.GoodSansB4};
    color: ${colors.white};
`

const FeaturedTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

`
